import React from 'react'
import styled from 'styled-components'
import logo from 'images/common/logo.svg'

const HeaderContainer = styled.header`
  position: sticky;
  top: 0;
  z-index: 101;
  display: flex;
  align-items: center;
  background-color: #fff;
  box-shadow: 0 .125rem .25rem rgba(34, 34, 34, .1);
  height: 3rem;
  padding: .5rem 1rem;

  @media ${props => props.theme.media.xl} {
    height: 4rem;
    min-height: 4rem;
    padding: 0 1.25rem;
  }
`

const Logo = styled.a`
  img {
    width: 120px;
  }

  @media ${props => props.theme.media.xl} {
    img {
      width: 160px;
    }
  }
`

export const StyledSimpleHeader: React.FC = () => {
  return (
    <>
      <HeaderContainer>
        <Logo href="/">
          <img src={logo} alt="クラウドワークス テック" />
        </Logo>
      </HeaderContainer>
    </>
  )
}
